// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","logo":"_3rhz","reviews":"_2u0a","review":"_2m3o","top":"h42R","star":"_3gfW","avatar":"eBmq","content":"_2mRG"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/TrustPilot/TrustPilot.scss
// module id = dNFh
// module chunks = 0